import React, {useEffect, useState} from 'react';
import _ from "lodash";
import {searchPrintfulStoresWithSearchCriteria} from "../../services/printful-stores-data.service";
import PrintfulStoresFilters from "./printful-stores-filters";
import ShowEmptyListMessage from "../../../design/components/common/show-empty-list-message";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";
import {PRINTFUL_STORES_FIELDS_LIST} from "../../constants/printful-stores.constant";
import {getSinglePrintfulInfo} from "../../services/printful-info-data.service";
import {PRINTFUL_INFO_IDS} from "../../constants/printful-info.constant";
import {syncPrintfulStores} from "../../../common/services/cloud-function-service";

const defaultFilterCriteria: any = {};

const PrintfulStoresList = () => {
    const [printfulStoresList, setPrintfulStoresList] = useState(null);
    const [printfulStoresInfo, setPrintfulStoresInfo] = useState(null);
    const [filterCriteria, setFilterCriteria] = useState(defaultFilterCriteria);
    const [dataFetchInProgress, setDataFetchInProgress] = useState(true);

    const getPrintfulStoresList = async () => {
        setDataFetchInProgress(true);

        const searchCriteriaList = [];

        _.forIn(filterCriteria, (value, attribute) => {
            if ((!_.isEmpty(value) || value === true) && value !== 'EMPTY') {
                searchCriteriaList.push({field: attribute, condition: '==', value: value});
            }
        });

        // const printfulStoresListResult = await searchPrintfulStoresWithSearchCriteria(searchCriteriaList);
        const printfulStoresInfoResult = await getSinglePrintfulInfo(PRINTFUL_INFO_IDS.PRINTFUL_STORES);

        setPrintfulStoresInfo(printfulStoresInfoResult);
        setPrintfulStoresList(printfulStoresInfoResult?.stores || []);
        setDataFetchInProgress(false);
    }

    useEffect(() => {
        getPrintfulStoresList();
    }, [filterCriteria]);

    const refreshPrintfulStoresList = async () => {
        await getPrintfulStoresList();
    }

    const startPrintfulStoresSyncProcess = async () => {
        setDataFetchInProgress(true);
        await syncPrintfulStores();

        await refreshPrintfulStoresList();
        setDataFetchInProgress(false);
    }

    return (
        <>

            <div className="flex justify-between">

                <div className="flex justify-start items-center mt-2 -ml-2 mb-2 w-full">
                    <div className={'text-xl ml-2'}>
                        Stores
                    </div>

                    {/*<PrintfulStoresFilters
                        filterCriteria={filterCriteria}
                        setFilterCriteria={setFilterCriteria}/>*/}

                    <div className="ml-4">
                        <ShowProgressSpinner dataFetchInProgress={dataFetchInProgress}/>
                    </div>
                </div>

                <div className="text-center w-1/3 flex items-center justify-end">
                    <div>
                        <button
                            className="button-green px-4 py-2 flex items-center justify-center"
                            onClick={startPrintfulStoresSyncProcess}>
                            <span>Sync Stores</span>
                        </button>
                    </div>
                </div>

            </div>

            <div className="flex justify-start">

                <div
                    className="w-full bg-white mt-4 rounded-lg">

                    <ShowEmptyListMessage
                        dataList={printfulStoresList}
                        dataFetchInProgress={dataFetchInProgress}
                        label={'Printful Stores'}/>

                    {printfulStoresList?.length > 0 &&
                        <table className="w-full">
                            <thead className="">
                            <tr>
                                <th className="p-2 border border-gray-400 sticky top-0 bg-gray-400 text-white w-12">S.No</th>
                                {PRINTFUL_STORES_FIELDS_LIST?.map((printfulStoresField, rowIndex) => (
                                    <th key={`th-${rowIndex}`}
                                        className={`p-2 border border-gray-400 sticky top-0 bg-gray-400 text-white text-left pl-2 ${printfulStoresField?.cssClass}`}>{printfulStoresField?.label}</th>
                                ))}
                                <th className="p-2 border border-gray-400 sticky top-0 bg-gray-400 text-white">
                                    Actions
                                </th>
                            </tr>
                            </thead>
                            <tbody className="">
                            {printfulStoresList?.map((printfulStores, rowIndex) => (
                                <tr key={`row-${rowIndex}`} className="border border-gray-400">
                                    <td className="p-2 border border-gray-400 m-auto">
                                        <div className="flex justify-center w-12">
                                            {rowIndex + 1}
                                        </div>
                                    </td>

                                    {PRINTFUL_STORES_FIELDS_LIST?.map((printfulStoresField, columnIndex) => (
                                        <React.Fragment key={`column-${rowIndex}-${columnIndex}`}>
                                            <td className={`p-2 border border-gray-400 m-auto ${printfulStoresField?.cssClass}`}>
                                                {printfulStoresField?.optionsMap &&
                                                    <>{printfulStoresField?.optionsMap[printfulStores[printfulStoresField?.attribute]]?.name}</>
                                                }

                                                {!printfulStoresField?.optionsMap &&
                                                    <>
                                                        {printfulStores[printfulStoresField?.attribute]}

                                                        {printfulStoresField?.secondaryAttribute &&
                                                            <div className={'text-gray-500 text-sm'}>
                                                                {printfulStores[printfulStoresField?.secondaryAttribute]}
                                                            </div>
                                                        }
                                                    </>
                                                }
                                            </td>
                                        </React.Fragment>
                                    ))}

                                    <td className="p-2 border border-gray-400 m-auto w-40">
                                        <div className="flex justify-center">

                                        </div>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    }
                </div>

            </div>

        </>
    );
}

export default PrintfulStoresList
